import React from "react";
import { getBreedersApplicationList, } from "../../../../actions/breeders";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import moment from "moment";
import { Loader } from "../../../../components/loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { BreadCrumb } from "../../../../components/breadcrumb";



const $ = window.$;
const { SearchBar } = Search;

const APPROVAL_STATUS = {
  pending : "pending",
  approved: "approved",
  rejected: "rejected",
  all: "all",
};

var _self;

function normalToPascal(s) {
  return s.replace(/\w+/g,
    function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });
}

const toCapitalize = (name) => {
  if (name && name.length > 1) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
}

class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
    _self = this;
  }
  state = {
    applicationAllData:[],
    applicationApprovedData:[],
    applicationRejectedData:[],
    loadingDelete: false,
    selectedTab: "all",
    loading: true,
    loadingBreeders: false,
    dataBreeders:[],
    breeder_application : [{

    }],

  };

  tableHeaderBreederColumnData = [
    {
      dataField: "actions",
      text: "Actions",
      formatter: this.buttonFormatter.bind(this),
      style: { "overflowX": "visible" },
      headerStyle: (column, colIndex) => {
        return { width: '70px' };
      }
    },
    {
      dataField: 'first_name', text: 'First Name', sort: true,
    },
    {
      dataField: 'last_name', text: 'Last Name', sort: true
    },
    {
      dataField: 'email', text: 'Email', sort: true,  formatter: (cell, row) => <a href={`mailto:${cell}?body=Hello, ${toCapitalize(row.first_name)}!`} className="hyperlink">{cell}</a>
    },
    {
      dataField: 'phone', text: 'Phone Number', sort: true, formatter: cell => <a href={`tel:${cell}`} className="hyperlink-phone-number">{cell}</a>
    },
    {
      dataField: 'approval_status', text: 'Status', sort: true,
      formatter: (cell, row) => {
        return (
          <div>   
            <div>
              <span
                className={
                  "m-badge mx-auto my-0 px-2 " +
                  (row.approval_status === APPROVAL_STATUS.approved
                    ? "m-badge--success"
                    : row.approval_status === APPROVAL_STATUS.rejected
                      ? "m-badge--danger mb-2"
                      : " m-badge--wide")
                }
              >    
                <strong>{ normalToPascal(cell)}</strong>  
              </span>     
          
            </div>
          </div>
   
           )}   
      
    },
    {
      dataField: 'createdAt', text: 'Created Date', formatter: cell => moment(cell).format('MM-DD-YYYY'), sort: true
    },
  ];

  buttonFormatter(cell, row, rowIndex) {
    return (
      <div>    
        <span className="dropdown show">
          <span className="dropdown">
            <a
              href=""
              className="btn m-btn m-btn--hover-brand m-btn--icon m-btn--icon-only m-btn--pill"
              data-toggle="dropdown"
              aria-expanded="true"
            >
              <i className="la la-ellipsis-h"></i>
            </a>
            <div className="dropdown-menu dropdown-menu-right">    
               <NavLink
                to={`/breeders/application/${row.id}`}
                 className="dropdown-item"
               >
                <span>               
                <i className="la la-eye pr-2"></i>  <span>View</span>
               </span>
              </NavLink>
               {/* Function in-progress */}
               {/* <a
                className="dropdown-item"
                onClick={(e) => { this.openBreederDeleteModal(e,row.id) }}
              >
                <i className="la la-trash-o"></i> Delete
              </a> */}
            </div>
          </span>
        </span>
      </div>
    );
  }

  openConfirmModal(e, mrId) {
    e.preventDefault();
    this.setState({ deleteMRId: mrId });
    $("#confirm_delete_modal").modal("show");
  }

  componentDidMount() {  
    this.props.getBreedersApplicationList();
    this.setState({ loading : true });
  }

  componentWillReceiveProps = nextProps => { 
    if (nextProps.data.breederReducer.breederApplications !== this.props.data.breederReducer.breederApplications) {
      let allApplications = nextProps.data.breederReducer.breederApplications; 
      let approvedList = [];
      let rejectedList = [];
      if(allApplications && allApplications.length > 0){
        approvedList = allApplications.filter(
          m => m.approval_status === APPROVAL_STATUS.approved  
        );
   
        rejectedList = allApplications.filter(   
          m => m.approval_status === APPROVAL_STATUS.rejected
        );
       
      }   
      this.setState({ applicationAllData: allApplications, applicationApprovedData : approvedList, applicationRejectedData :  rejectedList, loading : false });
    }

    if(nextProps.data.breederReducer.breederApplicationsError && nextProps.data.breederReducer.breederApplicationsError !== this.props.data.breederReducer.breederApplicationsError ){  
      NotificationManager.error("An error occurred while loading the breeders applications");
      this.setState({ loading : false });
    }

    if (this.props.data.breederReducer.deletedBreeder !== nextProps.data.breederReducer.deletedBreeder) {
      this.setState({ loadingDelete: false });
      $('#confirm_delete_modal').modal('hide');
      this.props.fetchBreeders();
      NotificationManager.success("Breeder Deleted Successfully");
    }
     


  };
  
  items = [{ title: "Breeders Applications", to: "/breeders/applications" }];

  render() {
    const { classes, theme, pdfStatus } = this.props;
    const {
      applicationAllData,
      applicationApprovedData,
      applicationRejectedData,
  
    } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <BreadCrumb items={this.items} />
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set" >
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Breeders Applications                   
                      </h3>
                    </div>
                  </div>
                  <div className="m-portlet__head-tools">        
            
                  </div>                
                </div>
                <div className="m-portlet__body medical-record-content">  
                <ul
                    className="nav nav-pills nav-pills--success m-nav-pills--btn-pill m-nav-pills--btn"
                    role="tablist"
                  >
                    <li className="nav-item m-tabs__item">
                      <button
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "all"
                        })}
                        onClick={() => this.setState({ selectedTab: "all" })}
                      >
                        All
                      </button>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "approved"
                        })}
                        onClick={() =>
                          this.setState({ selectedTab: "approved" })
                        }
                      >
                        Approved
                      </a>
                    </li>
                    <li className="nav-item m-tabs__item">
                      <a
                        className={classnames({
                          "nav-link m-tabs__link pl-4 pr-4 btn m-btn--pill btn-secondary m-btn m-btn--custom m-border-color-none": true,
                          active: this.state.selectedTab === "rejected"
                        })}
                        onClick={() => this.setState({ selectedTab: "rejected" })}
                      >
                       Rejected
                      </a>
                    </li>     
          
                  </ul>

                {this.state.loading ?
                  <div className="center-row" >
                    <Loader size={50} />  
                  </div>
                   :         
            
                    <ToolkitProvider
                      keyField="id"
                      data={
                        this.state.selectedTab === APPROVAL_STATUS.all            
                        ? applicationAllData
                        : this.state.selectedTab === APPROVAL_STATUS.approved
                        ? applicationApprovedData  
                        : this.state.selectedTab === APPROVAL_STATUS.rejected
                            ? applicationRejectedData
                            : {}
                      } 
                      columns={this.tableHeaderBreederColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {props => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon">
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                            </div>
                          </div>                 
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                              pagination={paginationFactory()}
                            />                        
                        </div>
                      )}
                    </ToolkitProvider>  
                    }            
                </div>
              </div> 
            </div>
          </div>
        </div>
        <div className="modal fade" id="confirm_delete_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirm to delete</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete this breeder?</p>
                        </div>
                        <div className="modal-footer">                    
                            <div>
                                <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                                <button type="button" onClick={(e) => this.deleteBreeder(e)} className="btn btn-primary m-btn--pill">Confirm</button>
                            </div>                    
                      
                        </div>
                    </div>
                </div>
        </div>   
      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state,


});

const mapDispatchToProps = dispatch => ({
  getBreedersApplicationList: () => {
    dispatch(getBreedersApplicationList());
  },
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);
